import { createContext } from "react"

import { BASE_MAP_ID, MAP_POINT_EDITOR_ID, REFERENTIAL_MAP_ID } from "../../constants/map"
import { MapStyles } from "../../constants/mapStyles"

export const initialStateContext = {
    desktopOpenPhoto: false,
    mapLayersState: {
        [BASE_MAP_ID]: {
            mapStyle: MapStyles.plan,
        },
        [MAP_POINT_EDITOR_ID]: {
            mapStyle: MapStyles.satellite,
        },
        [REFERENTIAL_MAP_ID]: {
            mapStyle: MapStyles.plan,
        },
    },
    error: false,
    fitOptions: null,
    displayReferential: true,
    imageLayerDisplayed: false,
    mapHeightPct: 100,
    legendOpened: false,
    mapBoundingBoxToFit: null,
    mapRefs: {},
    mapType: null,
    storedBoundingBox: {
        network: null,
        road: null,
    },
    layerClickListeners: {},
    userLocation: null,
}
const initialDispatchContext = {}

export const MapStateContext = createContext(initialStateContext)
export const MapDispatchContext = createContext(initialDispatchContext)
